import { createAction, props, select } from "@ngrx/store";
import { EducationCategoryDto } from '../interfaces/education_category_dto';
import { EducationTitleDto } from "../interfaces/education_title_dto";
import { EducationBodyDto } from "../interfaces/education_body_dto";
import { LessonRatingDto } from "src/app/lessons/interfaces/lesson_rating";
import { CustomerDto } from "src/app/auth/interfaces/customer_dto";
import { ServiceDto } from "../interfaces/service_dto";
import { SubscriptionDto } from "../interfaces/subscription_dto";

export const loadEducationCategories = createAction(
  "[Settings] Load Education Categories"
);

export const loadEducationCategoriesSuccess = createAction(
  "[Settings] Load Education Categories Success",
  props<{ educationCategories: EducationCategoryDto[] }>()
);

export const loadEducationTitles = createAction(
  "[Settings] Load Education Titles"
);

export const loadEducationTitlesSuccess = createAction(
  "[Settings] Load Education Titles Success",
  props<{ educationTitles: EducationTitleDto[] }>()
);

export const loadEducationBodies = createAction(
  "[Settings] Load Education Bodies"
);

export const loadEducationBodiesSuccess = createAction(
  "[Settings] Load Education Bodies Success",
  props<{ educationBodies: EducationBodyDto[] }>()
);

export const loadEducationTitlesForCategory = createAction(
  "[Settings] Load Education Titles For Category",
  props<{ educationCategoryId: number }>()
);

export const loadEducationTitlesForCategorySuccess = createAction(
  "[Settings] Load Education Titles For Category Success",
  props<{ educationTitles: EducationTitleDto[] }>()
);

export const loadEducationBodiesForTitle = createAction(
  "[Settings] Load Education Bodies For Title",
  props<{ educationTitleId: number }>()
);

export const loadEducationBodiesForTitleSuccess = createAction(
  "[Settings] Load Education Bodies For Title Success",
  props<{ educationBodies: EducationBodyDto[] }>()
);

export const updateEducationTitles = createAction(
  "[Settings] Update Education Titles",
  props<{ educationTitles: EducationTitleDto[] }>()
);

export const updateEducationTitlesSuccess = createAction(
  "[Settings] Update Education Titles Success",
  props<{ educationTitles: EducationTitleDto[] }>()
);

export const updateEducationBodies = createAction(
  "[Settings] Update Education Bodies",
  props<{ educationBodies: EducationBodyDto[] }>()
);

export const updateEducationBodiesSuccess = createAction(
  "[Settings] Update Education Bodies Success",
  props<{ educationBodies: EducationBodyDto[] }>()
);

export const addEducationCategory = createAction(
  "[Settings] Add Education Category",
  props<{ educationCategory: EducationCategoryDto }>()
);

export const addEducationCategorySuccess = createAction(
  "[Settings] Add Education Category Success",
  props<{ educationCategory: EducationCategoryDto }>()
);

export const updateEducationCategory = createAction(
  "[Settings] Update Education Category",
  props<{ educationCategory: EducationCategoryDto }>()
);

export const updateEducationCategorySuccess = createAction(
  "[Settings] Update Education Category Success",
  props<{ educationCategory: EducationCategoryDto }>()
);

export const deleteEducationCategory = createAction(
  "[Settings] Delete Education Category",
  props<{ educationCategory: EducationCategoryDto }>()
);

export const deleteEducationCategorySuccess = createAction(
  "[Settings] Delete Education Category Success",
  props<{ educationCategory: EducationCategoryDto }>()
);

export const undoDeleteEducationCategory = createAction(
  "[Settings] Undo Delete Education Category",
  props<{ educationCategory: EducationCategoryDto }>()
);

export const addEducationTitle = createAction(
  "[Settings] Add Education Title",
  props<{ educationTitle: EducationTitleDto }>()
);

export const addEducationTitleSuccess = createAction(
  "[Settings] Add Education Title Success",
  props<{ educationTitle: EducationTitleDto }>()
);

export const updateEducationTitle = createAction(
  "[Settings] Update Education Title",
  props<{ educationTitle: EducationTitleDto }>()
);

export const updateEducationTitleSuccess = createAction(
  "[Settings] Update Education Title Success",
  props<{ educationTitle: EducationTitleDto }>()
);

export const deleteEducationTitle = createAction(
  "[Settings] Delete Education Title",
  props<{ educationTitle: EducationTitleDto }>()
);

export const deleteEducationTitleSuccess = createAction(
  "[Settings] Delete Education Title Success",
  props<{ educationTitle: EducationTitleDto }>()
);

export const undoDeleteEducationTitle = createAction(
  "[Settings] Undo Delete Education Title",
  props<{ educationTitle: EducationTitleDto }>()
);

export const addEducationBody = createAction(
  "[Settings] Add Education Body",
  props<{ educationBody: EducationBodyDto }>()
);

export const addEducationBodySuccess = createAction(
  "[Settings] Add Education Body Success",
  props<{ educationBody: EducationBodyDto }>()
);

export const updateEducationBody = createAction(
  "[Settings] Update Education Body",
  props<{ educationBody: EducationBodyDto }>()
);

export const updateEducationBodySuccess = createAction(
  "[Settings] Update Education Body Success",
  props<{ educationBody: EducationBodyDto }>()
);

export const deleteEducationBody = createAction(
  "[Settings] Delete Education Body",
  props<{ educationBody: EducationBodyDto }>()
);

export const deleteEducationBodySuccess = createAction(
  "[Settings] Delete Education Body Success",
  props<{ educationBody: EducationBodyDto }>()
);

export const undoDeleteEducationBody = createAction(
  "[Settings] Undo Delete Education Body",
  props<{ educationBody: EducationBodyDto }>()
);

export const selectEducationCategory = createAction(
  "[Settings] Select Education Category",
  props<{ educationCategory: EducationCategoryDto }>()
);

export const selectEducationTitle = createAction(
  "[Settings] Select Education Title",
  props<{ educationTitle: EducationTitleDto }>()
);

export const addLessonRatings = createAction(
  "[Calendar] Add Lesson Rating",
  props<{ lessonRatings: LessonRatingDto[] }>()
);

export const addLessonRatingsSuccess = createAction(
  "[Calendar] Add Lesson Rating Success",
  props<{ lessonRatings: LessonRatingDto[] }>()
);

export const removeLessonRatings = createAction(
  "[Calendar] Remove Lesson Rating",
  props<{ lessonRatings: LessonRatingDto[] }>()
);

export const removeLessonRatingsSuccess = createAction(
  "[Calendar] Remove Lesson Rating Success",
  props<{ lessonRatings: LessonRatingDto[] }>()
);

export const loadLessonRatings = createAction("[Calendar] Load Lesson Ratings");

export const loadLessonRatingsSuccess = createAction(
  "[Calendar] Load Lesson Ratings Success",
  props<{ lessonRatings: LessonRatingDto[] }>()
);

export const loadLessonRatingsForLesson = createAction(
  "[Calendar] Load Lesson Ratings For Lesson",
  props<{ lessonId: number }>()
);

export const loadLessonRatingsForLessonSuccess = createAction(
  "[Calendar] Load Lesson Ratings For Lesson Success",
  props<{ lessonRatings: LessonRatingDto[] }>()
);

export const loadLessonRatingsForStudent = createAction(
  "[Calendar] Load Lesson Ratings For Student",
  props<{ studentId: number }>()
);

export const loadLessonRatingsForStudentSuccess = createAction(
  "[Calendar] Load Lesson Ratings For Student Success",
  props<{ lessonRatings: LessonRatingDto[] }>()
);

export const upsertLessonRatings = createAction(
  "[Student] Upsert Lesson Rating",
  props<{ lessonRatings: LessonRatingDto[] }>()
);

export const disconnectGoogleCalendar = createAction(
  "[Settings] Disconnect Google Calendar",
  props<{ customerId: number }>()
)

export const disconnectGoogleCalendarSuccess = createAction(
  "[Settings] Disconnect Google Calendar Success",
  props<{ customer: CustomerDto }>()
)

export const disconnectLocalCalendar = createAction(
  "[Settings] Disconnect Local Calendar",
  props<{ customerId: number }>()
)

export const disconnectLocalCalendarSuccess = createAction(
  "[Settings] Disconnect Local Calendar Success",
  props<{ customer: CustomerDto }>()
)

export const loadServices = createAction(
  "[Settings] Load Services",
)

export const loadServicesSuccess = createAction(
  "[Settings] Load Services Success",
  props<{ services: ServiceDto[] }>()
)

export const loadSubscriptions = createAction(
  "[Settings] Load Subscriptions",
)

export const loadSubscriptionsSuccess = createAction(
  "[Settings] Load Subscriptions Success",
  props<{ subscriptions: SubscriptionDto[] }>()
)

export const upsertService = createAction(
  "[Settings] Add Service",
  props<{ service: ServiceDto }>()
)

export const upsertServiceSuccess = createAction(
  "[Settings] Add Service Success",
  props<{ service: ServiceDto }>()
)

export const upsertSubscription = createAction(
  "[Settings] Add Subscription",
  props<{ subscription: SubscriptionDto }>()
)

export const upsertSubscriptionSuccess = createAction(
  "[Settings] Add Subscription Success",
  props<{ subscription: SubscriptionDto }>()
)

export const deleteService = createAction(
  "[Settings] Delete Service",
  props<{ serviceId: number }>()
)

export const deleteServiceSuccess = createAction(
  "[Settings] Delete Service Success",
  props<{ serviceId: number }>()
)

export const deleteSubscription = createAction(
  "[Settings] Delete Subscription",
  props<{ subscriptionId: number }>()
)

export const deleteSubscriptionSuccess = createAction(
  "[Settings] Delete Subscription Success",
  props<{ subscriptionId: number }>()
)

export const selectSetting = createAction(
  "[Settings] Select Setting",
  props<{ setting: "lessons" | "products" | "company" | "payments" | "calendar" | "education" | "education-category" | "education-title" | "reports" | "preferences" | "pro-subscription" | "support-info" }>()
)
